import fetch from '../utils/fetch.js';
import { pushFormSubmission as gtmPushFormSubmission } from '../utils/gtm';
import { FRONTEND_GIFTS_URL, FRONTEND_CNET_URL } from '../utils/constants';

const debug = require('debug')('cw:api:webform.js');

/**
 * Submit webform form to the backend.
 *
 */
export const submitWebform = async (data) => {
  try {
    // Send an event to GTM.
    gtmPushFormSubmission(data.webform_id);

    // Make a request to the webform endpoint.
    const response = await fetch('/webform_rest/submit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
      query: {
        // Backend uses the parameter to pick up correct site settings.
        frontend: window.location.host.startsWith('gifts') ? FRONTEND_GIFTS_URL : FRONTEND_CNET_URL,
      },
      throwNotOk: false,
    });

    const result = {};

    if (response.body.message) {
      result.errorMessage = response.body.message;
    }
    if (response.body.error) {
      const error = Object.values(response.body.error)[0];
      result.errorMessage = error;
    }

    if (response.body.sid) {
      result.submissionId = response.body.sid;
    }
    return result;
  } catch (error) {
    debug('Could not submit webform.', error);
    return {
      errorMessage: "Sorry, we couldn't submit the form. Please review your details and try again.",
    };
  }
};
